import { h } from 'preact'

interface Props {
    type?: string,
    startAt: number,
    title: string,
    destinationUrl?: string
}
const EventCalendarRow = ({ destinationUrl, title, type, startAt }: Props) => {
  // TODO move to Event date formatter
  const lang = navigator.language
  const date = new Date(startAt * 1000)
  const month = date.toLocaleDateString(lang, { month: 'short' })
  const day = date.getDate()
  return (
    <a href={destinationUrl} className='event-calendar-row__url qa-event-calendar-url'>
      <div className='event-calendar-row'>
        <div className='event-calendar-icon-wrapper'>
          <div className='event-calendar-icon-container'>
            <div className='event__month'><span>{month}</span></div>
            <div className='event__date'>{day}</div>
          </div>
        </div>
        <div className='event-detail-container'>
          {type && <div className='event__type'>{type}</div> }
          <a href={destinationUrl} className='event__title qa-event-title- url'>{title}</a>
        </div>
      </div>
    </a>
  )
}
export default EventCalendarRow
